import ownerWindow from './ownerWindow';
export default function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/getComputedStyle.js
// module id = 981
// module chunks = 0